import { Message } from "@carousel-office/shared/context/ConversationContext";
import {
  rewriteConversationFromUserTurn as rewriteSharedConversationFromUserTurn,
  type RewriteConversationResult,
} from "@carousel-office/shared";
import { rebuildSearchHistoryFromMessages } from "../../main/globals/global-state/searchHistory";
export type { RewriteConversationResult };

export interface RewriteConversationOptions {
  title?: string;
}

export async function rewriteConversationFromUserTurn(
  conversationId: string,
  userTurnOrdinal: number,
  sourceUiMessages: Message[],
  options?: RewriteConversationOptions
): Promise<RewriteConversationResult> {
  return rewriteSharedConversationFromUserTurn(conversationId, userTurnOrdinal, sourceUiMessages, {
    title: options?.title,
    primaryAgentType: "livePowerPointOrchestrator",
    rebuildSearchHistoryFromMessages,
  });
}
